import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createSettingEmails = (data) => ({
  type: ActionTypes.SETTING_EMAILS_CREATE,
  payload: {
    data,
  },
});

export const updateSettingEmails = (id, data) => ({
  type: ActionTypes.SETTING_EMAILS_UPDATE,
  payload: {
    id,
    data,
  },
});

/* Events */

export const createSettingEmailsRequested = (data) => ({
  type: ActionTypes.SETTING_EMAILS_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createSettingEmailsSucceeded = (settingEmails) => ({
  type: ActionTypes.SETTING_EMAILS_CREATE_SUCCEEDED,
  payload: {
    settingEmails,
  },
});

export const createSettingEmailsFailed = (error) => ({
  type: ActionTypes.SETTING_EMAILS_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createSettingEmailsReceived = (settingEmails) => ({
  type: ActionTypes.SETTING_EMAILS_CREATE_RECEIVED,
  payload: {
    settingEmails,
  },
});

export const updateSettingEmailsRequested = (id, data) => ({
  type: ActionTypes.SETTING_EMAILS_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateSettingEmailsSucceeded = (settingEmails) => ({
  type: ActionTypes.SETTING_EMAILS_UPDATE_SUCCEEDED,
  payload: {
    settingEmails,
  },
});

export const updateSettingEmailsFailed = (error) => ({
  type: ActionTypes.SETTING_EMAILS_UPDATE_FAILED,
  payload: {
    error,
  },
});

export const updateSettingEmailsReceived = (settingEmails) => ({
  type: ActionTypes.SETTING_EMAILS_UPDATE_RECEIVED,
  payload: {
    settingEmails,
  },
});

export const fetchSettingEmailsRequested = () => ({
  type: ActionTypes.SETTING_EMAILS_FETCH_REQUESTED,
  payload: {},
});

export const fetchSettingEmailsSucceeded = (data) => ({
  type: ActionTypes.SETTING_EMAILS_FETCH_SUCCEEDED,
  payload: {
    data,
  },
});

export const fetchSettingEmailsFailed = (error) => ({
  type: ActionTypes.SETTING_EMAILS_FETCH_FAILED,
  payload: {
    error,
  },
});
